import { Card, Box, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import { toast } from "sonner";
import { CheckCircle, Error, AssignmentLate } from "@mui/icons-material";

const RegistrationSection = ({ onClick, isEnrolled }) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <Card
      sx={{
        height: "100%",
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        transition: "0.3s",
        "&:hover": { boxShadow: 6 },
      }}
    >
      <Box textAlign="center" mb={2}>
        <Typography variant="h5" fontWeight="bold">
          Get Started With Your Research Journey
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        {/* Project Status */}
        <Box display="flex" alignItems="center" gap={1}>
          <AssignmentLate color="warning" />
          <Typography variant="body1" fontWeight="medium">
            <b>Status:</b>{" "}
            <span style={{ color: "#f44335" }}>No Project Registered</span>
          </Typography>
        </Box>

        {/* Enrollment Status */}
        <Box display="flex" alignItems="center" gap={1}>
          {isEnrolled ? (
            <CheckCircle color="success" />
          ) : (
            <Error color="error" />
          )}
          <Typography variant="body1" fontWeight="medium">
            <b>Enrollment Status:</b>{" "}
            <span style={{ color: isEnrolled ? "#4caf50" : "#f44335" }}>
              {isEnrolled ? "Enrolled" : "Not Enrolled"}
            </span>
          </Typography>
        </Box>

        {/* Action Button */}
        <MDButton
          variant="gradient"
          color="info"
          sx={{ mt: 2, width: "80%" }}
          onClick={
            isEnrolled
              ? handleClick
              : () =>
                  toast.warning(
                    "You must enroll for the current academic year!"
                  )
          }
        >
          Register
        </MDButton>
      </Box>
    </Card>
  );
};

export default RegistrationSection;
